<template>
  <div class="color" style="display: flex; justify-content: space-between;">
    <div class="font">
      T-DASHコマンドメーカー
    </div>
    <v-btn class="delete-btn click-cursor" @click="resetForm(index)">入力をリセット</v-btn>
    <v-snackbar v-model="showToast" location="top" color="success" :min-width=0 text="フォームをリセットしました。(未実装)"
      :timeout=1500></v-snackbar>
  </div>
</template>

<script>
import { ref } from 'vue'

import cacheUtils from '@/js/cacheUtils';

export default {
  name: 'HeaderMenu',
  setup() {
    const showToast = ref(false)
    const resetForm = async () => {
      await cacheUtils.resetData()
      location.reload()
      // showToast.value = true
    }

    return {
      showToast,
      resetForm,
    }
  }
}
</script>

<style scoped>
.color {
  color: white;
  background-color: #0D1F38;
}

.font {
  align-content: center;
  font-size: larger;
  padding-left: 10px;
}

.delete-btn {
  background-color: #ff4900;
  color: white;
  margin-right: 24px;
  height: 4vh !important;
  align-self: center;
  border: unset;
}

.delete-btn:hover {
  background-color: #ba3501;
}
</style>
